<template>
    <div class="fixed  inset-0 z-50 flex items-center justify-center bg-black/50">
        <div class="bg-white rounded-[10px] shadow-lg max-[1000px]:mx-[20px]">
            <!-- Header -->
            <div class="bg-primary rounded-t-[10px] px-6 py-3 flex justify-between items-center h-[48px]">
                <span class="text-white s !text-[14px]">ประกาศเหตุฉุกเฉิน</span>
                <button @click="$emit('close')"
                    class="text-primary bg-white rounded-full text-2xl leading-none p-2 hover:text-gray-200">
                    <XmarkIcon class="w-2.5 h-2.5 text-primary" color="#9B237B" />
                </button>
            </div>
            <!-- Content -->
            <div class="w-[1000px] max-[1000px]:w-full  h-[642px] flex flex-col">
                <!-- โซนที่เลื่อน: ฟอร์มทั้งหมดก่อนเส้น -->
                <div class="flex-1 overflow-y-auto overflow-x-hidden p-[20px]">
                    <div class="text-center justify-items-center">
                        <AlertIcon class="w-[50px] h-[50px]" />
                        <div class="M text-primary-dark M !text-[16px] !font-medium">
                            ประกาศเหตุฉุกเฉิน
                        </div>
                        <!-- {{ data }} -->
                        <div v-if="data?.created_at" class="mt-[10px] PC_Body1-R">
                            ประกาศเมื่อ : {{ formatThaiDateTime(data?.created_at) }}
                        </div>
                        <div v-if="data?.updated_at" class="PC_Body1-R">
                            อัปเดตล่าสุด : {{ formatThaiDateTime(data?.updated_at) }}
                        </div>
                    </div>

                    <div class="mt-[16px]">
                        <Input label="จังหวัดที่เกิดเหตุ" placeholder="จังหวัดที่เกิดเหตุ" v-model="form.nameProvince"
                            :warningMessage="false" disabled />
                    </div>

                    <div class="flex mx-auto w-full gap-[10px] mt-[16px] max-[1000px]:flex-col-reverse">
                        <!-- {{ typeDisaterOption }} -->
                        <div class="flex-1">
                            <!-- {{ typeDisaterOption }} -->
                            <SelectBox3 inputClass="h-[42px] w-full" id="typeAlert" label="ประเภทภัยพิบัติ"
                                placeholder="เลือกประเภทภัยพิบัติ" :options="typeDisaterOption"
                                :optionToDisplay="'name'" :valueKey="'id'" v-model="form.type_id" />
                            <!-- :disabled="hasData" -->
                        </div>
                        <div class="flex-1">
                            <SelectBox inputClass="h-[42px] w-full" id="levelAlert" label="ระดับภัยพิบัติ"
                                placeholder="เลือกระดับภัยพิบัติ" :options="levelDisaterOption" v-model="form.level" />
                        </div>
                    </div>

                    <div class="mt-[16px]">
                        <div class="text-primary-dark title !text-[16px]">
                            เลือกพื้นที่ที่ได้รับผลกระทบ (เลือกอย่างน้อย 1 ตัวเลือก)
                        </div>
                        <div class="mt-[10px] grid grid-cols-3 gap-[10px] max-[1000px]:grid-cols-2">
                            <!-- ... Radio  -->
                            <Radio id="dis1" name="affectedDistricts" label="เมืองเชียงราย" value="เมืองเชียงราย"
                                v-model="form.affectedDistricts" />
                            <Radio id="dis2" name="affectedDistricts" label="เวียงชัย" value="เวียงชัย" v-model="form.affectedDistricts" />
                            <Radio id="dis3" name="affectedDistricts" label="แม่ลาว" value="แม่ลาว" v-model="form.affectedDistricts" />
                            <Radio id="dis4" name="affectedDistricts" label="แม่จัน" value="แม่จัน" v-model="form.affectedDistricts" />
                            <Radio id="dis5" name="affectedDistricts" label="ดอยหลวง" value="ดอยหลวง" v-model="form.affectedDistricts" />
                            <Radio id="dis6" name="affectedDistricts" label="พาน" value="พาน" v-model="form.affectedDistricts" />
                            <Radio id="dis7" name="affectedDistricts" label="พญาเม็งราย" value="พญาเม็งราย" v-model="form.affectedDistricts" />
                            <Radio id="dis8" name="affectedDistricts" label="เวียงเชียงรุ้ง" value="เวียงเชียงรุ้ง"
                                v-model="form.affectedDistricts" />
                            <Radio id="dis9" name="affectedDistricts" label="ป่าแดด" value="ป่าแดด" v-model="form.affectedDistricts" />
                            <Radio id="dis10" name="affectedDistricts" label="แม่สรวย" value="แม่สรวย" v-model="form.affectedDistricts" />
                            <Radio id="dis11" name="affectedDistricts" label="เชียงแสน" value="เชียงแสน" v-model="form.affectedDistricts" />
                            <Radio id="dis12" name="affectedDistricts" label="ขุนตาล" value="ขุนตาล" v-model="form.affectedDistricts" />
                            <Radio id="dis13" name="affectedDistricts" label="แม่สาย" value="แม่สาย" v-model="form.affectedDistricts" />
                            <Radio id="dis14" name="affectedDistricts" label="เทิง" value="เทิง" v-model="form.affectedDistricts" />
                            <Radio id="dis15" name="affectedDistricts" label="แม่ฟ้าหลวง" value="แม่ฟ้าหลวง" v-model="form.affectedDistricts" />
                            <Radio id="dis16" name="affectedDistricts" label="เวียงป่าเป้า" value="เวียงป่าเป้า"
                                v-model="form.affectedDistricts" />
                            <Radio id="dis17" name="affectedDistricts" label="เวียงแก่น" value="เวียงแก่น" v-model="form.affectedDistricts" />
                            <Radio id="dis18" name="affectedDistricts" label="เชียงของ" value="เชียงของ" v-model="form.affectedDistricts" />

                        </div>
                    </div>

                    <div class="mt-[16px]">
                        <div class="text-primary-dark title !text-[16px]">
                            ต้องการส่งแจ้งเตือนไปทางไลน์ OA
                        </div>
                        <div class="mt-[10px] grid grid-cols-3 gap-x-4 gap-y-2 max-[1000px]:grid-cols-1">
                            <Radio id="Notiwant1" name="Notiwant" label="ต้องการ" customLabel="text-primary-dark"
                                :value="1" v-model="form.notify" />
                            <Radio id="Notiwant2" name="Notiwant" label="ไม่ต้องการ" customLabel="text-primary-dark"
                                :value="0" v-model="form.notify" />
                        </div>
                    </div>
                </div>

                <!-- ฟุตเตอร์:  ไม่เลื่อน -->
                <div class="border-t border-[#DFDCDD] p-[20px] bg-white rounded-b-[10px]">
                    <div class="flex justify-end">
                        <button
                            class="w-[144px] h-[50px] bg-[#9B237B] rounded-[6px] text-white M disabled:cursor-not-allowed disabled:!bg-[#DFDCDD] disabled:!text-[#B7B2B5]"
                            :disabled="!isFormValid" @click="submitAnnouncement">
                            {{ data ? "อัปเดตเหตุฉุกเฉิน" : "ประกาศเหตุฉุกเฉิน" }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch, toRefs, nextTick, onMounted, onUnmounted } from "vue";
import Radio from "../Utilities/Radio.vue";
import { useDisaterRequestStore } from "@/pinia/disater";
import axios from "axios";
import SelectBox3 from "../../components/Modals/SelectBox3.vue";

// ---- stores ----
const DisaterRequestStore = useDisaterRequestStore();

// ---- props / emits ----
const props = defineProps({
    data: { type: [String, Number, Boolean, Object], default: null },
});
const { data } = toRefs(props);
const emit = defineEmits(["success", "close", "error"]);

// const hasData = computed(() => !!props.data && Object.keys(props.data).length > 0)

// ---- options / maps ----
const typeDisaterOption = ref([
    // 'แสดงทุกภัยพิบัติ',
    // 'อุทกภัย',
    // 'ดินถล่ม',
    // 'ไฟป่า',
    // 'หมอกควัน',
    // 'พายุฤดูร้อน',
    // 'แผ่นดินไหว',
    // 'อัคคีภัย',
    // 'โรคระบาด',
]);
const levelDisaterOption = ref([
    // 'แสดงทุกระดับ',
    "ระดับ 1 : สาธารณภัยขนาดเล็ก จัดการได้ภายในอำเภอ",
    "ระดับ 2 : จัดการได้ภายในจังหวัด",
    "ระดับ 3 : ระดับภาคหรือส่วนกลาง ระดับกรมเข้ามาช่วยจัดการ",
    "ระดับ 4 : ระดับชาติ",
]);

const disasterNameToId = {
    อุทกภัย: 2,
    ดินถล่ม: 3,
    ไฟป่า: 4,
    หมอกควัน: 5,
    พายุฤดูร้อน: 6,
    แผ่นดินไหว: 7,
    อัคคีภัย: 8,
    โรคระบาด: 9,
};

const districtNameToId = {
    เมืองเชียงราย: 5701,
    เวียงชัย: 5702,
    เชียงของ: 5703,
    เทิง: 5704,
    พาน: 5705,
    ป่าแดด: 5706,
    แม่จัน: 5707,
    เชียงแสน: 5708,
    แม่สาย: 5709,
    แม่สรวย: 5710,
    เวียงป่าเป้า: 5711,
    พญาเม็งราย: 5712,
    เวียงแก่น: 5713,
    ขุนตาล: 5714,
    แม่ฟ้าหลวง: 5715,
    แม่ลาว: 5716,
    เวียงเชียงรุ้ง: 5717,
    ดอยหลวง: 5718,
};

const provinceNameToId = {
    เชียงราย: 57,
    เชียงใหม่: 50,
    กรุงเทพมหานคร: 10,
};

// ---- form state ----
const form = ref({
    nameProvince: "เชียงราย",
    type_id: null,
    level: "",
    notify: 1,
    affectedDistricts: "",
});

//onMounted
onMounted(async () => {
    document.body.style.overflow = "hidden";

    await getDisater();
});
onUnmounted(() => {
    document.body.style.overflow = "";
});

async function getDisater() {
    try {
        const s = await axios.get("/disaster");
        const raw = Array.isArray(s.data?.data) ? s.data.data : [];

        // ➕ prepend "แสดงทุกภัยพิบัติ" (id=0) แล้วตามด้วยรายการจริงจาก API
        typeDisaterOption.value = [
            // { id: 1, name: 'แสดงทุกภัยพิบัติ', disable: 0 },
            ...raw,
        ];
    } catch (error) {
        console.error("getDisater", error);
    }
}
// normalize incoming data -> form
function normalizeForm(d) {
    return {
        nameProvince: "เชียงราย",
        type_id: d?.disaster_id ?? null,
        level: d?.level != null ? levelNumberToOption(d.level) : "",
        notify: Number(d?.line_oa ?? 1),
        affectedDistricts: d.gis_map,
    };
}

watch(
    data,
    (d) => {
        if (d) form.value = normalizeForm(d);
    },
    { immediate: true }
);

// watch(() => isOpen, (v) => {
//   document.body.style.overflow = v ? 'hidden' : ''
// }, { immediate: true })

const isFormValid = computed(
    () =>
        form.value.nameProvince &&
        form.value.type_id != null &&
        form.value.level &&
        form.value.notify !== null &&
        form.value.affectedDistricts.length > 0
);
const isEdit = computed(() => Boolean(data?.value && data.value.id));

// ---- helpers ----
function parseLevel(levelStr) {
    const m = String(levelStr ?? "").match(/\d+/);
    return m ? Number(m[0]) : null;
}

function formatThaiDateTime(isoString) {
    if (!isoString) return "";
    const d = new Date(isoString);

    // แปลงเป็นไทย (บวก 543 ปี)
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear() + 543;

    // เวลา ชั่วโมง.นาที
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}`;
}

// ---- submit ----
async function submitAnnouncement() {
    try {
        const provinceName = (form.value?.nameProvince ?? "").trim();
        let province_id = provinceNameToId?.[provinceName];
        if (
            !province_id &&
            typeof provinceOptions !== "undefined" &&
            Array.isArray(provinceOptions)
        ) {
            province_id = provinceOptions.find(
                (p) => p.name_th === provinceName || p.name_en === provinceName
            )?.id;
        }
        if (!province_id) throw new Error(`province_id not found for "${provinceName}"`);

        // กันเคส "แสดงทุกภัยพิบัติ" ไม่ให้ map ผิด
        const rawType = (form.value?.type || "").trim();
        const disaster_id = disasterNameToId[rawType] ?? null;

        const district_code =
            districtNameToId[String(form.value?.affectedDistricts || "").trim()] ?? null;

        const payload = {
            disaster_id: Number(form.value.type_id),
            level: Number(parseLevel(form.value?.level) ?? 0),
            province_id,
            district_code,
            line_oa: Number(form.value?.notify ?? 0),
        };

        // console.log("PAYLOAD:", payload);

        // 👇 โหมดสองแบบอยู่ตรงนี้
        if (isEdit.value) {
            const editId = data.value.id; // ชัวร์ละว่ามี
            await DisaterRequestStore.postDiasater(payload, editId); // => /post/{id}
        } else {
            await DisaterRequestStore.postDiasater(payload); // => /post
        }

        const successMsg = isEdit.value
            ? "ระบบได้ อัปเดต ภัยพิบัติ สำเร็จ"
            : "ระบบได้ ประกาศ ภัยพิบัติ สำเร็จ";

        emit("success", successMsg); // ← ส่งข้อความ
        emit("close");
        emit("close");
    } catch (err) {
        const msg = err?.response?.data?.message || err?.message || "submit failed";
        console.error("ERROR:", msg);
        emit("error", msg);
        throw new Error(msg);
    }
}

function levelNumberToOption(n) {
    const target = `ระดับ ${Number(n)}`;
    return levelDisaterOption.value.find((s) => s.startsWith(target)) || "";
}

// ---- debug (optional) ----
// watch(
//     () => form.value.notify,
//     (nv) => {
//         console.log("line_oa:", nv);
//     }
// );

watch(
    [data, typeDisaterOption],
    () => {
        if (!form.value.type_id && data?.value?.disaster_name) {
            const hit = typeDisaterOption.value.find(
                (o) => o.name === data.value.disaster_name
            );
            if (hit) form.value.type_id = hit.id;
        }
    },
    { immediate: true }
);

watch(
    [data, levelDisaterOption],
    ([d]) => {
        if (d?.level != null) {
            const label = levelNumberToOption(d.level);
            if (label && form.value.level !== label) form.value.level = label;
        }
    },
    { immediate: true }
);
</script>
